export default "__VITE_ASSET__B1U7tMxT__"